const firebaseConfig = {
    apiKey: "AIzaSyC4VJpbTNCdcMcCAM959oz9pnPM8lD_lBs",
    authDomain: "e-health-hospital.firebaseapp.com",
    projectId: "e-health-hospital",
    storageBucket: "e-health-hospital.appspot.com",
    databaseURL: "https://e-health-hospital-default-rtdb.firebaseio.com",
    messagingSenderId: "1041483673337",
    appId: "1:1041483673337:web:d62df718fdfc09bc673c28"
  };
  export default firebaseConfig;